import { DITypes, LocalStorageKeys } from "@/core/@types/types";
import { type IStorage } from "@/core/plugins/storage/Storage";
import axios from "axios";
import { inject, injectable } from "inversify";

type IResponseFinancasDevHttp<T> = {
  statusCode?: number;
  Ok?: boolean;
  Result?: T;
  Data?: T;
  Errors?: string;
  Total?: number;
  Error?: string;
};

export interface IFinancasDevHttp {
  get(
    url: string,
    params?: Record<string, any>
  ): Promise<IResponseFinancasDevHttp<any>>;
  post(url: string, data: unknown): Promise<IResponseFinancasDevHttp<any>>;
  patch(url: string, data: unknown): Promise<IResponseFinancasDevHttp<any>>;
  delete(url: string): Promise<IResponseFinancasDevHttp<any>>;
}

export const FinancasDevHttpDi = Symbol("FinancasDevHttpDi");

@injectable()
export default class FinancasDevHttp implements IFinancasDevHttp {
  @inject(DITypes.STORAGE) private storage!: IStorage;

  protected headers() {
    return {
      Authorization: `Bearer ${this.storage.get(LocalStorageKeys.Token) || ""}`,
      Referer: import.meta.env.VITE_APP_FINANCAS_URL,
      Accept: "application/json, text/plain, */*",
      "Accept-Language": "pt-BR,pt;q=0.9,en;q=0.8",
      "sec-ch-ua":
        '"Chromium";v="134", "Not:A-Brand";v="24", "Google Chrome";v="134"',
      "sec-ch-ua-mobile": "?0",
      "sec-ch-ua-platform": '"Windows"',
      "User-Agent":
        "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36"
    };
  }

  get = async (
    url: string,
    params?: Record<string, any>
  ): Promise<IResponseFinancasDevHttp<any>> => {
    const response = await axios.get(url, {
      headers: this.headers(),
      withCredentials: true,
      params
    });

    return response.data;
  };

  post = async (
    url: string,
    data: unknown
  ): Promise<IResponseFinancasDevHttp<any>> => {
    const response = await axios.post(url, data, {
      headers: this.headers(),
      withCredentials: true
    });

    return response.data;
  };

  patch = async (
    url: string,
    data: unknown
  ): Promise<IResponseFinancasDevHttp<any>> => {
    const response = await axios.patch(url, data, {
      headers: this.headers(),
      withCredentials: true
    });

    return response.data;
  };

  delete = async (url: string): Promise<IResponseFinancasDevHttp<any>> => {
    const response = await axios.delete(url, {
      headers: this.headers(),
      withCredentials: true
    });

    return response.data;
  };
}
